import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { startEmployeeOnlyBasicFecth, singleEmployeeOnlyBasicDataSelector } from 'store1/employees data/employeesData.slice.selector';
import {
    isLoadingSelector,
    startSingleEmployeeAllPayrollCTC_EmployeeId,
    singleEmployeeAllCTCPayrollsSelector
} from 'store1/payrolls data/payrollDataSlice.Selector';
import EmployeeDataAndActiveCTC from "./ReviseEmployeePayrollRoute/ReusableComponet/ParentReusableRoute/employeeDataAndActiveCtc";
import EmployeeReviseListData from "./ReviseEmployeePayrollRoute/EmployeeReviseList/employeeReviseListData";

const RevisePayrollIndexWrapper = () => {
    const { emp_id } = useParams();
    const dispatch = useDispatch();
    const [activeData, setActiveData] = useState({});
    const [activeCTCData, setActiveCTCData] = useState({
        annual_ctc: '',
        hra: '',
        special_allowance: '',
        fixed: '',
        added_date: new Date().toDateString()
    });

    useEffect(() => {
        dispatch(startSingleEmployeeAllPayrollCTC_EmployeeId(emp_id));
        dispatch(startEmployeeOnlyBasicFecth(emp_id));
    }, [emp_id, dispatch]);

    const singleEmployeeAllCTCPayrolls = useSelector(singleEmployeeAllCTCPayrollsSelector);
    const singleEmployeeOnlyBasic = useSelector(singleEmployeeOnlyBasicDataSelector);
    const isLoading = useSelector(isLoadingSelector);

    useEffect(() => {
        setActiveData(singleEmployeeAllCTCPayrolls?.find((item) => item.status === 1));
        let findDataActive = singleEmployeeAllCTCPayrolls?.find((item) => item.status === 1);
        if (findDataActive) {
            let montlyCTC = findDataActive?.annual_ctc / 12;
            let basicAmount = Math.round(montlyCTC * (findDataActive?.basic / 100));
            let hraAmount = Math.round(basicAmount * (findDataActive?.hra / 100));
            setActiveCTCData({
                ...findDataActive,
                hra: hraAmount,
                fixed: Math.round(montlyCTC - basicAmount - hraAmount - findDataActive?.special_allowance)
            });
        }
    }, [singleEmployeeAllCTCPayrolls]);

    return (
        <>
            <EmployeeDataAndActiveCTC
                activeCTCData={activeCTCData}
                singleEmployeeAllCTCPayrolls={singleEmployeeAllCTCPayrolls}
                singleEmployeeOnlyBasic={singleEmployeeOnlyBasic}
            />
            <EmployeeReviseListData
                isLoadingPayrollData={Boolean(isLoading)}
                singleEmployeeAllCTCPayrolls={singleEmployeeAllCTCPayrolls}
                singleEmployeeOnlyBasic={singleEmployeeOnlyBasic}
            />
        </>
    );
};

export default RevisePayrollIndexWrapper;